export default "__VITE_ASSET__B$ywSSjf__"